import { ROUTE_PERMISSIONS } from '@shared/permissions';
import { PermissionGuard } from '@shared/router';
import { Route } from 'react-router-dom';

import { reportsPath } from './urls';

export const ReportRoutes = (
  <>
    <Route
      path={reportsPath}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.reports}>
          <h1>Report Page</h1>
        </PermissionGuard>
      }
    />
  </>
);
